import PaginationRequest from '@/common/pagination/entities/pagination-request'

export default class HistoryFilter {
  public paging: PaginationRequest = new PaginationRequest()
}
